import { ChartExamples } from '@/pages/branding/examples/ChartExamples.tsx'
import { InterfaceExample } from '@/pages/branding/examples/InterfaceExample.tsx'
import { SettingsLogo } from '@/pages/branding/logo/SettingsLogo.tsx'
import { SettingsColorPicker } from '@/pages/branding/sections/colorPicker/SettingsColorPicker.tsx'
import { SettingsPrimarySecondary } from '@/pages/branding/sections/SettingsPrimarySecondary.tsx'
import { CheckOutlined } from '@ant-design/icons'
import { Button, Col, Flex, Row } from 'antd'
import { customizationApi } from 'common/api/entitiesApi.tsx'
import { FormCard } from 'common/components/FormCard.tsx'
import { useAppContext } from 'common/context/AppContext.tsx'
import { useUserContext } from 'common/context/UserContext.tsx'
import { colorPaletteManager, defaultColorPalette } from 'common/util/colorPalette.ts'
import { userUpdateStore } from 'common/util/userUpdateStore.tsx'
import { showMessage } from 'common/util/Util.tsx'
import React, { useEffect, useRef, useState } from 'react'

export const Branding: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { messageApi } = useAppContext()

  const { colorPalette: globalPalette } = useUserContext()

  const [colorPalette, setColorPalette] = useState(globalPalette)

  useEffect(() => {
    setColorPalette(globalPalette)
  }, [globalPalette])

  useEffect(() => {
    if (containerRef.current) {
      colorPaletteManager.update(colorPalette, containerRef.current)
    }
  }, [colorPalette])

  function reset() {
    customizationApi.uploadCustomSettings(defaultColorPalette).then(() => {
      showMessage(messageApi, 'Success', 'Settings are successfully reset!')
      setColorPalette(defaultColorPalette)
      userUpdateStore.updateInfo()
    })
  }

  function apply() {
    customizationApi.uploadCustomSettings(colorPalette).then(() => {
      showMessage(messageApi, 'Success', 'Settings are successfully saved!')
      userUpdateStore.updateInfo()
    })
  }

  return (
    <>
      <SettingsLogo type="logo" />
      <SettingsLogo type="favicon" />

      <div ref={containerRef}>
        <FormCard title="Custom system colors">
          <Row>
            <Col>
              <SettingsPrimarySecondary colorPalette={colorPalette} setColorPalette={setColorPalette} />
            </Col>

            <Col style={{ marginLeft: 30 }}>
              <ChartExamples />
            </Col>
          </Row>
        </FormCard>
        <FormCard title="Sidebar/header color">
          <Row>
            <Col>
              <SettingsColorPicker
                value={colorPalette['--color-system-1']}
                onChange={(color) => {
                  setColorPalette({
                    ...colorPalette,
                    '--color-system-1': color.toHexString(),
                  })
                }}
              />
            </Col>

            <Col style={{ marginLeft: 220 }}>
              <InterfaceExample />
            </Col>
          </Row>
        </FormCard>
      </div>

      <Row>
        <Col span="4" />
        <Col span="20">
          <Flex style={{ marginTop: 20, marginRight: 24, marginLeft: 16 }}>
            <Flex gap="middle" justify="flex-start" align="flex-start">
              <Button type="primary" className="adsp-button" htmlType="button" onClick={apply}>
                <CheckOutlined /> Apply
              </Button>
              <Button type="primary" className="adsp-button" htmlType="button" ghost onClick={reset}>
                Reset settings
              </Button>
            </Flex>
          </Flex>
        </Col>
      </Row>
    </>
  )
}
